<template>
  <div class="pagination-container" v-if="totalPages > 1">
    <button class="page-btn" :disabled="currentPage === 1" @click="changePage(currentPage - 1)">Previous</button>
    <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
    <button class="page-btn" :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">Next</button>
  </div>
</template>

<script>
export default {
  name: 'AppPagination',
  props: {
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit('page-changed', page);
      }
    }
  }
}
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  padding: 10px;
}
.page-btn {
  padding: 6px 14px;
  border: 1px solid #cbd5e1;
  background-color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  color: #334155;
  font-size: 0.9rem;
  font-weight: 500;
}
.page-btn:hover:not(:disabled) {
  background-color: #f1f5f9;
  border-color: #94a3b8;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-info {
  font-size: 0.9rem;
  color: #475569;
  font-weight: 500;
}
</style>
